<template>
  <div class="mainPage">
    <div class="header_banner">
    </div>
    <div class="content">
      <div class="leftBox">
        <div class="box">
          <div class="titleBox" v-for="(item, index) in subject_info" :key="item.id"
            :class="{ active: active === index }" @click="getCollectInfo(item, index)">
            <div class="title">
              <span class="title_cn">{{ item.name }}</span>
              <span class="title_en">{{ item.name_en }}</span>
            </div>

            <img src="../img/chineseCultureVideoExhibition2025/icon1.png" alt="" class="icon" />
          </div>
        </div>
      </div>

      <div class="rightBox">
        <div class="back_arrow" @click="goBack()"> &lt; </div>
        <div class="video_wrap">
          <div class="cover_con" v-if="!showVideo && videoInfo && videoInfo.cover_url" @click="showVideo = true">
            <img src="../img/chineseCultureVideoExhibition2025/play.png" alt="" class="play_icon">
            <img :src="videoInfo.cover_url" alt="" class="video_cover">
          </div>
          <div class="videoContainer" v-if="showVideo">
            <video :src="videoInfo.video_url" id="liveVideo" autoplay controls controlsList="nodownload"></video>
          </div>
          <ul class="video_list" v-show="subjectDetail.type == 1">
            <li v-for="(v, i) in videoList" :class="{ active: videoIndex == i }" :key="i" @click="playVideo(i)">{{ i }}
            </li>
            <div class="link" @click="goProgramLink()">
              <img src="../img/chineseCultureVideoExhibition2025/link.png" alt="" class="link_icon">
              <div class="name_con">
                <p class="cn">节目链接</p>
                <p class="en">Program link</p>
              </div>
            </div>
          </ul>
          <div class="link_con" v-show="subjectDetail.type == 2">
            <div class="link" @click="goProgramLink()" v-if="subjectDetail.internal_address">
              <img src="../img/chineseCultureVideoExhibition2025/link.png" alt="" class="link_icon">
              <div class="name_con">
                <p class="cn">节目链接</p>
                <p class="en">Program link</p>
              </div>
            </div>
            <div class="link" @click="goOverseasLink()" v-if="subjectDetail.external_address">
              <img src="../img/chineseCultureVideoExhibition2025/link.png" alt="" class="link_icon">
              <div class="name_con">
                <p class="cn">外网链接</p>
                <p class="en">Overseas Links</p>
              </div>
            </div>
          </div>
        </div>
        <div class="projectProfile detail">
          <div class="box">
            <div class="name_cn">{{ subjectDetail.name }}</div>
            <div class="name_en">{{ subjectDetail.name_en }}</div>
            <div class="text">
              {{ subjectDetail.describe }}
            </div>
            <div class="text2">
              {{ subjectDetail.describe_en }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer">
      <img src="../img/chineseCultureVideoExhibition/2026/pc/footer.png" />
    </div>

    <transition name="fade">
      <div id="videoPlayWrapper" v-if="isPlay" @mousewheel.prevent>
        <div class="videoContent">
          <div class="closeVideo" @click="closeVideo()">×</div>
          <div class="videoContainer">
            <video :src="currentVideoUrl" id="liveVideo" autoplay controls controlsList="nodownload"></video>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "chinese_Culture_Video_Exhibition_2026_detail",
  metaInfo() {
    return {
      title: "2026魅力中文,中央广播电视总台精品节目展播",
      meta: [
        {
          name: "keyword",
          content: "2026魅力中文,中央广播电视总台,精品节目展播",
        },
        {
          name: "description",
          content: "2026魅力中文 中央广播电视总台精品节目展播",
        },
      ],
    };
  },
  data: function () {
    return {
      isPlay: false,
      currentVideoUrl: "",
      imgUrl: "",
      subject_info: [],
      videoList: [],
      showVideo: false,
      active: 0,
      collection_id: "",
      videoIndex: 0,
      subjectDetail: "",
      videoInfo: {
        cover_url: "",
      },
    };
  },
  created() {
    this.collection_id = this.$route.query.collection_id
    this.videoIndex = this.$route.query.videoIndex

    this.getCollectList();
    this.getSubjectInfo();
    this.getVideoList();
  },
  methods: {
    goBack() {
      this.$router.push({
        path: "/pcpage/cmgp2026",
      });
    },
    goProgramLink() {
      window.open(this.subjectDetail.internal_address);
    },
    goOverseasLink() {
      window.open(this.subjectDetail.external_address);
    },
    getCollectList() {
      this.$utils
        .get("/subject/lesson_Collection/getlist", {
          limit: 999,
          alias: 'cmgp2026',
        })
        .then((res) => {
          if (res.data.success) {
            this.subject_info = res.data.data.list
            this.active = this.subject_info.findIndex((v) => {
              return v.id == this.collection_id
            })
          }
        });
    },
    getVideoList() {
      this.$utils
        .get("/subject/lesson/getlist", {
          collection_id: this.collection_id,
          order: 'sort',
          limit: 30
        })
        .then((res) => {
          if (res.data.success) {
            this.videoList = res.data.data.list
            this.videoInfo = this.videoList[this.videoIndex]
          }
        });
    },
    getSubjectInfo() {
      this.$utils
        .get("/subject/lesson_Collection/read", {
          id: this.collection_id,
        })
        .then((res) => {
          if (res.data.success) {
            this.subjectDetail = res.data.data
          }
        })
    },
    getCollectInfo(item, index) {
      this.active = index
      this.$router.push({
        path: '/pcpage/cmgp2026_detail',
        query: {
          collection_id: item.id,
          videoIndex: 0
        }
      })
      this.collection_id = this.$route.query.collection_id
      this.videoIndex = 0
      this.showVideo = false
      this.videoInfo = {}
      this.getSubjectInfo()
      this.getVideoList()
    },
    playVideo(index) {
      this.showVideo = false;
      this.videoIndex = index;
      this.videoInfo = this.videoList[index];
    },
    //播放课程
    replay(url, cover) {
      // console.log(url)
      this.currentVideoUrl = url;
      this.imgUrl = cover;
      this.isPlay = true;
      setTimeout(function () {
        //
        $("#liveVideo").bind("contextmenu", function () {
          return false;
        }); //为video添加禁止右键另存为操作
      }, 50);
    },
    closeVideo() {
      var myvideo = document.getElementById("liveVideo");
      if (!myvideo.paused) {
        //视频正在播放中时停止播放
        myvideo.pause();
      }
      this.isPlay = false;
    }
  },
};
</script>

<style scoped lang="scss">
.mainPage {
  width: 100%;
  text-align: center;
  position: relative;
  min-height: 100%;
  user-select: none;

  .header_banner {
    position: relative;
    z-index: -1;
    background-image: url(../img/chineseCultureVideoExhibition/2026/pc/header.png);
    height: 640px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }

  .content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: 1400px;
    // height: 2860px;
    margin: auto;
    margin-top: -30px;

    .leftBox {
      width: 20%;
      height: fit-content;
      margin-left: -105px;
      text-align: end;
      border-right: 1px solid rgb(138, 138, 138);
      position: sticky;
      top: 80px;

      .box {
        display: flex;
        flex-direction: column;
        margin-right: -33px;
        margin-top: 15px;
        margin-bottom: 15px;

        .titleBox {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          cursor: pointer;

          .title {
            padding: 7px 10px;
            display: flex;
            flex-direction: column;
            margin-right: 45px;

            .title_cn {
              font-size: 18px;
              line-height: 30px;
              color: #364347;
            }

            .title_en {
              font-size: 12px;
              font-family: DINCond-Medium;
              color: #93a4aa;
            }
          }

          .icon {
            width: 55px;
            height: 21px;
            display: none;
          }
        }

        .titleBox.active {
          .title {
            margin-right: 15px;

            .title_cn {
              font-weight: bold;
              color: #973300;
            }

            .title_en {
              color: #973300;
            }
          }

          .icon {
            display: block;
          }
        }
      }
    }

    .rightBox {
      width: 80%;
      display: flex;
      flex-direction: column;
      text-align: left;
      margin-left: 110px;
      margin-bottom: 370px;
      margin-top: -100px;

      .projectProfile {
        position: relative;
        background: url(../img/chineseCultureVideoExhibition2025/kuang.png) no-repeat center;
        background-size: 100% 100%;
        margin-bottom: 30px;

        &.detail {
          .box {
            .text {
              margin-top: 10px;
              padding-left: 20px;
              padding-right: 20px;
            }

            .text2 {
              padding-left: 20px;
              padding-right: 20px;
            }
          }
        }

        .kuang1 {
          position: absolute;
          margin-top: 10px;
          z-index: 100;
        }

        .icon3 {
          position: absolute;
          top: 0;
        }

        .icon4 {
          position: absolute;
          bottom: 15px;
          right: 45px;
        }

        .box {
          width: 95%;
          // height: 250px;
          z-index: 10;
          margin: auto;
          margin-top: 10px;
          margin-bottom: 40px;

          .name_cn {
            font-size: 30px;
            font-weight: bold;
            color: #282828;
            margin-bottom: 10px;
            padding-left: 20px;
            padding-top: 20px;
          }

          .name_en {
            font-size: 18px;
            font-weight: bold;
            color: #93a4aa;
            padding-left: 20px;

          }

          .text {
            font-size: 16px;
            color: #282828;
            padding-top: 18px;
            padding-left: 35px;
            padding-right: 55px;
            margin-top: 25px;
            line-height: 26px;
            text-align: justify;
            text-indent: 2em;
          }

          .text2 {
            font-size: 15px;
            color: #282828;
            padding-left: 35px;
            padding-right: 55px;
            line-height: 24px;
            padding-bottom: 10px;
            text-align: justify;
            // text-indent:2em;
          }
        }
      }

      .back_arrow {
        font-size: 40px;
        color: #fff;
        cursor: pointer;
        margin-bottom: 20px;
      }

      .video_wrap {
        .cover_con {
          position: relative;
          cursor: pointer;

          .play_icon {
            position: absolute;
            left: 15px;
            bottom: 15px;
            width: 60px;
          }

          .video_cover {
            display: block;
            width: 1100px;
            height: 619px;
            border: solid 2px #e0ac68;
            margin-bottom: 25px;
          }
        }

        .videoContainer {
          width: 1100px;
          height: 619px;
          margin-bottom: 25px;

          video {
            width: 100%;
            height: 100%;
          }
        }

        .video_list {
          margin-bottom: 30px;
          overflow: hidden;

          li {
            width: 71px;
            height: 71px;
            float: left;
            margin-right: 15px;
            border-radius: 10px;
            background-image: linear-gradient(0deg,
                rgba(231, 217, 206, 1) 0%,
                #f8f4f1 100%);
            border: 1px solid rgba(186, 159, 125, 1);
            font-size: 40px;
            color: #a1896b;
            font-weight: bold;
            line-height: 70px;
            text-align: center;
            cursor: pointer;
            margin-bottom: 10px;

            &.active {
              background-image: linear-gradient(0deg,
                  rgba(231, 217, 206, 1) 0%,
                  #f8f4f1 100%);
              border: 1px solid rgba(186, 159, 125, 1);
              color: #973300;
            }
          }

          .link {
            height: 73px;
            float: left;
            padding: 0 26px;
            box-sizing: border-box;
            border-radius: 10px;
            background-image: linear-gradient(0deg,
                rgba(231, 217, 206, 1) 0%,
                #f8f4f1 100%);
            border: 1px solid rgba(186, 159, 125, 1);
            display: flex;
            align-items: center;
            cursor: pointer;

            .link_icon {
              margin-right: 15px;
            }

            .name_con {
              color: #a1896b;
              font-weight: bold;

              .cn {
                font-size: 18px;
              }

              .en {
                font-size: 16px;
              }
            }
          }
        }

        .link_con {
          display: flex;
          align-items: center;
          justify-content: center;

          .link {
            height: 73px;
            float: left;
            padding: 0 26px;
            box-sizing: border-box;
            border-radius: 10px;
            background-image: linear-gradient(0deg,
                rgba(231, 217, 206, 1) 0%,
                #f8f4f1 100%);
            border: 1px solid rgba(186, 159, 125, 1);
            display: flex;
            align-items: center;
            cursor: pointer;
            margin-bottom: 30px;

            &:nth-child(1) {
              margin-right: 23px;
            }

            .link_icon {
              margin-right: 15px;
            }

            .name_con {
              color: #a1896b;
              font-weight: bold;

              .cn {
                font-size: 18px;
              }

              .en {
                font-size: 16px;
              }
            }
          }
        }
      }

      .classBox {
        .series_info {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .info_left {
            .cloud_con {
              width: 136px;
              height: 100px;
              background: url(../img/chineseCultureVideoExhibition2025/cloud.png) no-repeat center;
              background-position-y: bottom;
              position: relative;
              float: left;

              .serise_icon_con {
                position: absolute;
                left: 25px;
                top: 15px;
                border: solid 3px #ffffff;

                img {
                  border-radius: 6px;
                  width: 60px;
                  height: 60px;
                  display: block;
                }
              }
            }

            .name_con {
              float: left;
              margin-top: 25px;
              margin-left: -30px;

              .cn {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 30px;
                color: #364347;
                margin-bottom: 4px;
              }

              .en {
                font-family: SourceHanSansCN;
                font-weight: bold;
                font-size: 16px;
                color: #93a4aa;
              }
            }
          }

          .look_detail_icon {
            cursor: pointer;
            width: 208px;
            height: 30px;
          }
        }

        .text_cn {
          font-size: 16px;
          color: #5e696d;
          line-height: 24px;
          margin-top: 20px;
          margin-bottom: 5px;
        }

        .text_en {
          font-size: 14px;
          color: #5e696d;
          line-height: 20px;
          // margin-bottom: 20px;
        }

        .swiper_con {
          margin-top: 25px;
          margin-left: 0rem;
          margin-bottom: 40px;
          position: relative;

          .swiper-container {
            position: unset;
          }

          .swiper {
            .swiper-slide {
              width: 3.6rem !important;

              .swiperBox {
                overflow: hidden;
              }
            }

            .video_con {
              width: 3.6rem;

              .huan_icon {
                display: block;
                // position: absolute;
                width: 0.78rem;
                bottom: 0;
                margin-top: -2rem;
                margin: auto;
                margin-top: -2rem;
                position: relative;
                z-index: 3;
              }

              .video_name_con {
                width: 4.8rem;
                height: 1.1rem;
                line-height: 1.2rem;
                font-weight: bold;
                background-color: #04c7de;
                border-radius: 0.2rem;
                border: solid 0.04rem #000000;
                font-family: HYJiJinTiW;
                text-align: center;
                font-size: 0.3rem;
                color: #ffffff;
                margin: auto;
                position: relative;
                z-index: 2;
                margin-top: -0.4rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
                padding: 0 0.2rem;
                box-sizing: border-box;
              }

              .video_cover {
                width: 3.6rem;
                height: calc(3.4rem / (16 / 9));
                background-color: #f6453f;
                // border-radius: .2rem;
                // border: solid .04rem #000000;
                // overflow: hidden;
                // margin-top: -.4rem;

                img {
                  display: block;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                }
              }

              .titleBox {
                position: absolute;
                height: 55px;
                margin-top: -55px;
                width: 100%;
                color: #fff;
                background-color: #55565775;
                text-align: left;
                z-index: 100;
                display: flex;
                align-items: center;

                .course_title {
                  padding: 10px 20px;

                  .cn {
                    font-size: 16px;
                  }

                  .en {
                    margin-top: 4px;
                    font-size: 14px;
                  }
                }
              }
            }
          }

          .swiper-button-prev {
            background-image: url(../img/chineseCultureVideoExhibition2025/prev.png);
            position: absolute;
            left: -75px;
            top: 90px;
          }

          .swiper-button-next {
            background-image: url(../img/chineseCultureVideoExhibition2025/next.png);
            right: -75px;
            top: 90px;
          }
        }

        .series_type2_con {
          overflow: hidden;
          margin-top: 15px;

          .cover {
            width: 352px;
            height: 220px;
            display: block;
            float: left;
            margin-right: 22px;
          }

          .des_con {
            font-size: 14px;
            color: #5e696d;
            line-height: 24px;
            float: left;
            width: calc(100% - 22px - 352px);

            .cn {
              margin-bottom: 13px;
              display: -webkit-box;
              /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical;
              /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 4;
              /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden;
              /* 隐藏超出的内容 */
            }

            .en {
              line-height: 20px;
              display: -webkit-box;
              /* 必须设置，用于多行溢出 */
              -webkit-box-orient: vertical;
              /* 设置盒子排列方向为垂直 */
              -webkit-line-clamp: 5;
              /* 限制显示的行数，例如显示 3 行 */
              overflow: hidden;
              /* 隐藏超出的内容 */
            }
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: auto;
    font-size: 0;

    img {
      width: 100%;
      object-fit: contain;
    }
  }

  #videoPlayWrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 999;
  }

  #videoPlayWrapper .closeVideo {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 50px;
    color: #fff;
    cursor: pointer;
  }

  .videoContent {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .videoContainer {
    text-align: center;
    width: 100%;
  }

  .videoContainer video {
    width: 62%;
  }

  video::-internal-media-controls-download-button {
    display: none;
  }

  video::-webkit-media-controls-enclosure {
    overflow: hidden;
  }

  video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
  }
}

// 110%
@media screen and (max-width: 1750px) {
  .mainPage .header_banner {
    height: 560px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 4rem !important;

        .video_con {
          width: 4rem;

          .video_cover {
            width: 4rem;
            height: calc(4rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .footer {
    margin-top: -360px;

    .copy {
      bottom: 100px;
    }
  }
}

// 125%
@media screen and (max-width: 1540px) {
  .mainPage .header_banner {
    height: 540px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 4.5rem !important;

        .video_con {
          width: 4.5rem;

          .video_cover {
            width: 4.5rem;
            height: calc(4.3rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }

  .mainPage .footer {
    margin-top: -400px;
  }
}

// 150%
@media screen and (max-width: 1280px) {
  .mainPage .header_banner {
    height: 410px;
  }

  .mainPage .content .rightBox .classBox .swiper_con {
    .swiper {
      .swiper-slide {
        width: 5rem !important;

        .video_con {
          width: 5rem;

          .video_cover {
            width: 5rem;
            height: calc(4.7rem / (16 / 9));
          }
        }
      }
    }

    .swiper-button-next[data-v-5f9973b2] {
      right: -60px;
    }
  }


  .projectProfile {
    transform: scale(0.9);
    margin-left: -100px;
  }

  .mainPage .content {
    .rightBox {
      transform: scale(0.9);
      margin-top: -140px;
      margin-left: 70px;
    }

    // height: 3000px;
    // transform: scale(0.8);
  }
}
</style>
